'use strict';

var Grid = require('../../DesignSystem/Layout/Grid/Grid.js');
require('prop-types');
var React = require('react');
var PartialNumberStarRating = require('./PartialNumberStarRating.js');
var ObjectHelper = require('../../common/ObjectHelper.js');
var Typography = require('../../node_modules/@material-ui/core/esm/Typography/Typography.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ReviewItem(_ref) {
  var comments = _ref.comments,
      date = _ref.date,
      firstName = _ref.firstName,
      lastName = _ref.lastName,
      rating = _ref.rating;
  return React__default["default"].createElement(Grid, {
    container: true,
    spacing: 8
  }, React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, React__default["default"].createElement(Typography["default"], {
    variant: "body1"
  }, displayLastNameInitial(firstName, lastName))), React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, React__default["default"].createElement(PartialNumberStarRating, {
    rating: rating,
    size: 12
  })), React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, React__default["default"].createElement(Typography["default"], {
    variant: "body2"
  }, comments)), React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, React__default["default"].createElement(Typography["default"], {
    variant: "caption"
  }, new Date(date).toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  }))));
}

function displayLastNameInitial(firstName, lastName) {
  if (ObjectHelper.isPresent(firstName) && ObjectHelper.isPresent(lastName)) {
    return firstName + ' ' + lastName[0].toUpperCase() + '.';
  } else if (ObjectHelper.isPresent(firstName)) {
    return firstName;
  } else if (ObjectHelper.isPresent(lastName)) {
    return lastName;
  } else {
    return "Anonymous";
  }
}

ReviewItem.defaultProps = {
  comments: '',
  name: ''
};

module.exports = ReviewItem;
